import React, { memo, PropsWithChildren } from 'react';

import { PageContextProvider, usePageContext } from './context';
import { usePageContextValue } from './functions';
import s from './index.module.css';
import { LeftSide } from './LeftSide';
import { RightSide } from './RightSide';
import { EPageLayout, IPageProps } from './types';

const Page = (props: IPageProps) => {
  const contextValue = usePageContextValue(props);

  return (
    <PageContextProvider value={contextValue}>
      <PageContextConsumer />
    </PageContextProvider>
  );
};

export default memo(Page);

const PageContextConsumer = () => {
  const { leftSideRef, rightSideRef } = usePageContext();

  return (
    <PageLayoutWrapper>
      <LeftSide ref={leftSideRef} />
      <RightSide ref={rightSideRef} />
    </PageLayoutWrapper>
  );
};

function PageLayoutWrapper({ children }: PropsWithChildren) {
  const { config } = usePageContext();

  if (config.layout === EPageLayout.FullWidth) return <div className={s.verticalOrientation}>{children}</div>;

  return <>{children}</>;
}
